export default __webpack_public_path__ + "static/media/pancake-swap.5eff0ea2.png";